/** 编写委员会成员角色（与后端 EDITORIAL_COMMITTEE_ROLES 一致） */
export const EDITORIAL_COMMITTEE_ROLES = [
  'AUTHOR',
  'DEPUTY_EDITOR',
  'EDITOR_IN_CHIEF',
  'ADMIN',
] as const

export type EditorialCommitteeRole = (typeof EDITORIAL_COMMITTEE_ROLES)[number]

function normalizeRole(role: string): string {
  return role.trim().toUpperCase()
}

/** 判断用户是否具备编写委员会成员角色 */
export function isEditorialCommitteeMember(roles: string[]): boolean {
  if (!roles?.length) return false
  const normalized = new Set(roles.map(normalizeRole))
  return EDITORIAL_COMMITTEE_ROLES.some((r) => normalized.has(r))
}

/** 合并 Redux roles 与 user.role 单值 */
export function collectUserRoles(roles: string[], userRole?: string): string[] {
  const merged = [...(roles || [])]
  if (userRole) {
    const upper = normalizeRole(userRole)
    if (!merged.some((r) => normalizeRole(r) === upper)) {
      merged.push(userRole)
    }
  }
  return merged
}
